import React, { useEffect, useRef, useState } from 'react'
import { InputMask } from 'primereact/inputmask'

import { InputDateProps } from './InputDateProps'
import { InputModes } from '../../../../models/form/IFieldsDefinition'

import '../InputBaseStyles.scss'

const InputDate = React.memo((props: InputDateProps) => {
   const PrimeInputMask = InputMask as any; // Hack - inaczej build na TeamCity nie przejdzie
   
   const {htmlInputType, field, debounceTime, value, setHasInputFocused, handleOnPaste, handleOnBlur, handleSaveInputValueToStateAndValid } = props   
   const [currentInputValue, setCurrentInputValue] = useState(value)
   const hasPageBeenRendered = useRef(false)
   const currentDateInput = document.getElementsByName(field.name)[0] as HTMLInputElement; // Aktualna kontrolka, WAŻNE ABY NAZWA KONTROLKI BYŁA UNIKALNA
   const [inputClear, setInputClear] = useState(true) //Hack używany do czyszczenia wartości kontrolki, w momencie zmiany typu dochodu na inny 

   const mask = "99/99/9999" // Maska nie jest przekazywana przez propsy (nie jest zapisana w definicji pola) ponieważ jest statyczna - wspólna dla każdej kontrolki tego typu w aplikacji
   const maskPlaceholder = "DD/MM/RRRR" 



   // =============================== USE EFFECT'S ===============================

   useEffect(() => { // Czyszczenie wartości z kontrolki przy zmianie na inny typ dochodu
      setCurrentInputValue(props.value)
      setInputClear(false)
   }, [props.value])

   useEffect(() => { //Debounce input
       const timeoutId = setTimeout(() => {
          if(hasPageBeenRendered.current && inputClear){ //Pierwsze błedy walidacyjne wyświetlamy dopiero gdy użytkownik zacznie uzupełniać kontrolki
             handleSaveInputValueToStateAndValid(currentInputValue)
             return
          }
 
          hasPageBeenRendered.current = true // Pierwszy render strony - nie chcemy od razu wyświetlać wszystkich błędów walidacyjnych
       }, debounceTime)
 
       return () => clearTimeout(timeoutId)
 
     // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentInputValue, hasPageBeenRendered])

   // ==========================================================================



   // =============================== HANDLERS ===============================

   const handleOnClick = () => {      
      const dateRegexp = /([0-9D]{2})\/([0-9M]{2})\/([0-9R]{4})/ //Wyrażenie regularne sprawdzające czy użytkownik zaczął uzupełniać maskę wartościami

      if(!dateRegexp.test(currentInputValue)){ // Jeśli użytkownik NIE ZACZĄŁ jeszcze uzupełniać maski, ustawiamy kursor na samym początku kontrolki
         currentDateInput?.setSelectionRange(0,0)
      }
   }

   const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {      
      field.parser !== undefined? setCurrentInputValue(field.parser(e.target.value)) : setCurrentInputValue(e.target.value)
      setInputClear(true)
   }
   // ==========================================================================


   return (
     <>
         <PrimeInputMask
            id={field.name}
            name={field.name}
            mask={mask} 
            slotChar={maskPlaceholder}
            autoClear={false}
            value={currentInputValue} 
            disabled={!field.editable}
            type={htmlInputType}
            inputMode={InputModes.numeric}
            onClick={handleOnClick}
            onFocus={() => setHasInputFocused(true)}
            onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => handleOnPaste && handleOnPaste(e)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(e)}
            onBlur={(e: React.FocusEvent) => {
               setHasInputFocused(false)
               handleOnBlur(e)
            }}  
         />
     </>
   );
 
})

export default InputDate;